import CustomerHome from "../../../jsx/components/Dashboard/CustomerHome";

const CustomerHomeWrapper = () => {
  return <CustomerHome />;
};

export default constore(CustomerHomeWrapper);
